import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const consumfinalAdapter = createEntityAdapter({})

const initialState = consumfinalAdapter.getInitialState()

export const consumfinalApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getconsumfinal: builder.query({
            query: (filter) => ({
                url: '/consumfinal',
                params: filter,
                validateStatus: (response, result) => {
                    return (response.status === 200 || response.status === 204) && !result.isError;
                },
            }),
            transformResponse: (responseData) => {
                // Handle empty array response
                if (!responseData || responseData.length === 0) {
                    return initialState;
                }
                
                // Transform response to use entity adapter
                const loadedConsumables = responseData.map(transaction => {
                    transaction.id = transaction._id; // Add the `id` field
                    return transaction;
                });
                
                return consumfinalAdapter.setAll(initialState, loadedConsumables);
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'CONSUMFINAL', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'CONSUMFINAL', id })),
                    ];
                } else {
                    return [{ type: 'CONSUMFINAL', id: 'LIST' }];
                }
            },
        }),
        addNewconsumfinal: builder.mutation({
            query: initialUserData => ({
                url: '/consumfinal',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'CONSUMFINAL', id: "LIST" }
            ]
        }),        
        updateconsumfinal: builder.mutation({
            query: initialUserData => ({
                url: '/consumfinal',
                method: 'PUT',
                body: {
                    ...initialUserData,
                },
                responseHandler: (response) => response.text(), // Backend returns plain text, not JSON
            }),
            transformResponse: (response) => {
                // Response is already text from responseHandler
                return { message: response }; // Wrap in object for consistency
            },
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMFINAL', id: 'LIST' }
            ]
        }),        
        deleteconsumfinal: builder.mutation({
            query: ({ id }) => ({
                url: `/consumfinal`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMFINAL', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetconsumfinalQuery,
    useAddNewconsumfinalMutation,
    useUpdateconsumfinalMutation,
    useDeleteconsumfinalMutation
} = consumfinalApiSlice

// returns the query result object
export const selectconsumfinalResult = consumfinalApiSlice.endpoints.getconsumfinal.select()

// creates memoized selector
const selectconsumfinalData = createSelector(
    selectconsumfinalResult,
    consumfinalResult => consumfinalResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllconsumfinal,
    selectById: selectconsumfinalById,
    selectIds: selectconsumfinalIds
    // Pass in a selector that returns the users slice of state
} = consumfinalAdapter.getSelectors(state => selectconsumfinalData(state) ?? initialState)